// extracted by mini-css-extract-plugin
export default {"modal":"WHuwG","animation":"UZqvF","title":"lURpY","text":"WaXEi","button":"nisvM"};